export function sortData<T>(
  data: T[],
  sortConfig: { column: keyof T | string | null; direction: "asc" | "desc" },
  columns: { id: keyof T | string; sortable?: boolean }[]
): T[] {
  if (!sortConfig.column) return data;
  const column = columns.find((col) => col.id === sortConfig.column);
  if (!column || !column.sortable) return data;

  return [...data].sort((a, b) => {
    const aValue = a[sortConfig.column as keyof T];
    const bValue = b[sortConfig.column as keyof T];
    if (aValue == null || bValue == null) return 0;

    if (typeof aValue === "string" && typeof bValue === "string") {
      return sortConfig.direction === "asc"
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    } else if (typeof aValue === "number" && typeof bValue === "number") {
      return sortConfig.direction === "asc"
        ? aValue - bValue
        : bValue - aValue;
    } else if (aValue instanceof Date && bValue instanceof Date) {
      return sortConfig.direction === "asc"
        ? aValue.getTime() - bValue.getTime()
        : bValue.getTime() - aValue.getTime();
    } else {
      return sortConfig.direction === "asc"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    }
  });
}